const ScrollViewport = {
  mounted() {
    this.handleScoll = (e) => {
      const elements = document.getElementsByClassName("header-wrapper");

      if (window.scrollY >= 150) {
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.add("scroll");
        }
      } else {
        for (let i = 0; i < elements.length; i++) {
          elements[i].classList.remove("scroll");
        }
      }
    };
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};

export default ScrollViewport;
